import { useFormikContext } from 'formik';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { Name } from '../../../models/Name';
import { getCredentialsTypeWithPagination } from '../../../services/credentialsService';
import { getErrorMessage } from '../../../services/utilities/ServiceError';
import { getStatusName } from '../../../utilities/CredentialUtil';
import CredentialDateInfo from '../credential-date-info';
import { WizardSummaryLayout, WizardSummarySection, WizardSummaryField } from '../../wizard/wizard-summary-layout';

interface Props {
    taskDescription: string;
    taskProcedure: string;
    onBack: (event: any) => void;
    isEdit: boolean,
}

const SummaryForm: FC<Props> = ({ taskDescription, taskProcedure, onBack, isEdit }) => {
    const { values } = useFormikContext<any>();
    const [credentialTypes, setcredentialTypes] = useState<Name[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCrentialTypes();
    }, [])

    const buildCrentialTypes = async () => {
        try {
            const type = await getCredentialsTypeWithPagination();
            setcredentialTypes(type.rows);
        } catch (error) {
            toast.warn(getErrorMessage(error));
        }
    }

    const getType = (typeId: number) => {
        let type: string = '';

        try { // prevent crash when a card type can't be determined. E.g. after MDE/Omnikey read.
            credentialTypes.forEach(item => {
                if (item.value === typeId.toString()) {
                    type = item.label;
                }
            })
        } catch (err) {
            const prefix = `Failed to get enrolled card type: `; // For context on where the error occurred.
            console.error(prefix + getErrorMessage(err));
        }

        return type;
    }

    return (
        <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
            {!isEdit ? (
                <WizardSummarySection heading={translate.byKey(TranslationKeys.taskDetails)}>
                    <WizardSummaryField label={translate.byKey(TranslationKeys.task)} value={taskDescription} />
                    <WizardSummaryField label={translate.byKey(TranslationKeys.procedure)} value={taskProcedure} />
                </WizardSummarySection>
            ) : null}
            <WizardSummarySection heading={translate.byKey(TranslationKeys.enrolmentDetails)}>
                <WizardSummaryField label={translate.byKey(TranslationKeys.tagCode)} value={values.tagDisplay} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.type)} value={getType(values.typeId)} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.status)} value={getStatusName(values.statusId, translate)} />
                {values.tagByteReversed === 1 ? (
                    <WizardSummaryField label={translate.byKey(TranslationKeys.mifareBytesReversed)} value={translate.byKey(TranslationKeys.yes)} />
                ) : null}
                {values.tagOss ? (
                    <WizardSummaryField label={translate.byKey(TranslationKeys.ossEnabled)} value={translate.byKey(TranslationKeys.yes)} />
                ) : null}
                <CredentialDateInfo values={values} />
            </WizardSummarySection>
        </WizardSummaryLayout>
    )
}

export default SummaryForm;
